export const titular = [
    {
        "nombre" : "Ricardo Gómez Moreno",
        "imagen" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/img/Titular.png",
        "funcion" : "Coordinar, ejecutar, evaluar, proponer y dar seguimiento a la política de desarrollo social y humano, para el combate efectivo a la pobreza y la marginación urbana y rural, diseñando estrategias que promuevan la participación ciudadana y la corresponsabilidad social."
    }
]